import { render, staticRenderFns } from "./LicenseDetail.vue?vue&type=template&id=3b852e8b&scoped=true&"
import script from "./LicenseDetail.vue?vue&type=script&lang=ts&"
export * from "./LicenseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseDetail.vue?vue&type=style&index=0&id=3b852e8b&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b852e8b",
  null
  
)

export default component.exports